import React, { memo } from "react";
import { TableCell } from "@mui/material";

import { UserClaims } from "core/contexts/auth/auth";

import CircleIcon from "@mui/icons-material/Circle";
import {
  AssignedToDropDown,
  StatusChangeDropDown,
} from "core/components/global/tables/datagrid/dataGridRows/datagridRows";
import {
  SpanActiveStatusStyled,
  SpanDeactiveStatusStyled,
} from "core/components/global/tables/datagrid/dataGrid.styled";
import { ShowActionPopup } from "./searchSimilar/showActionPopup";
import SeverityPopoverCell from "./searchSimilar/severityCell";
import { v4 as uuid4 } from "uuid";

interface AssigneeCellProps {
  users?: UserClaims[];
  handleAssignedTo: (email: string, id: string) => void;
  rowId: string;
  defaultValue: string;
}

export const AssigneeCell = memo(function AssigneeCell({
  users,
  handleAssignedTo,
  rowId,
  defaultValue,
}: AssigneeCellProps) {
  return (
    <TableCell>
      <AssignedToDropDown
        users={users}
        handleAssignedTo={handleAssignedTo}
        sortField="given_name"
        rowId={rowId}
        defaultValue={defaultValue.trim()}
      />
    </TableCell>
  );
});

interface StatusCellProps {
  value: string;
  statusMapping: Record<string, string>;
  handleSetStatus: (status: string, id: string) => void;
  rowId: string;
  userEmail?: string;
  rowEmail?: string;
}

export const StatusCell = memo(function StatusCell({
  value,
  statusMapping,
  handleSetStatus,
  rowId,
  userEmail,
  rowEmail,
}: StatusCellProps) {
  return (
    <TableCell>
      {statusMapping && statusMapping[value] ? (
        <SpanActiveStatusStyled>
          {userEmail === rowEmail ? (
            value
          ) : (
            <StatusChangeDropDown
              statusMapping={statusMapping}
              statuses={Object.keys(statusMapping)}
              handleSetStatus={handleSetStatus}
              rowId={rowId}
              defaultValue={value}
            />
          )}
        </SpanActiveStatusStyled>
      ) : (
        <>
          <CircleIcon
            style={{
              color: "grey",
              verticalAlign: "middle",
              fontSize: 12,
              marginRight: 5,
            }}
          />
          <SpanDeactiveStatusStyled>{value}</SpanDeactiveStatusStyled>
        </>
      )}
    </TableCell>
  );
});

interface ActionsCellProps {
  rowId: string;
  type: string;
  onActionClick?: (rowId: string, type: string) => void;
}

export const ActionsCell = memo(function ActionsCell({
  rowId,
  type,
  onActionClick,
}: ActionsCellProps) {
  // Provide a default no-op function if onActionClick is undefined
  const handleActionClick = onActionClick || ((id: string, actionType: string) => {
    console.log("No action handler provided for:", id, actionType);
  });
  
  return (
    <TableCell>
      <ShowActionPopup
        rowId={rowId}
        type={type}
        onActionClick={handleActionClick}
      />
    </TableCell>
  );
});

interface SeverityCellProps {
  name: string;
  key: string;
  value: string;
  index: number;
}
export const SeverityCell = memo(function SeverityCell({
  name,
  key,
  value,
  index,
}: SeverityCellProps) {
  return (
    <TableCell>
      <SeverityPopoverCell
        findingName={name}
        findingId={uuid4() as string}
        value={value}
        key={key}
        index={index}
      />
    </TableCell>
  );
});
